<template>
  <div>
    <McProgressBar
      :value="value"
      :min="min"
      :max="max"
      :label-position="labelPosition"
    ></McProgressBar>
  </div>
</template>
<script>
import McProgressBar from './index.vue'
export default {
  components: {
    McProgressBar,
  },
  props: {
    value: {
      type: Number,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
    labelPosition: {
      type: String,
    },
  },
}
</script>
